import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from './auth.econtract.service';
import {switchMap, take} from 'rxjs/operators';
import * as env from 'src/environments/environment';

const environment = (env as any).environment || env;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (environment.elisTranslatorUrl && request.url.startsWith(environment.elisTranslatorUrl)) {
            return next.handle(request);
        }
        return this.authService.isAuthenticated.pipe(
            take(1),
            switchMap((isAuthenticated) => {
                if(!isAuthenticated){
                    this.authService.handleTokenExpired();
                }
                return next.handle(request);
            })
        );
    }
}